import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

const IconContainer = styled.div<{ checkWeight?: string }>`
  max-width: ${({ checkWeight }) => checkWeight ?? '40px'};
`;

export default function IconsChecked({ checkWeight }: { checkWeight: string }): JSX.Element {
  const logoImage: any = useStaticQuery(graphql`
    {
      contentfulAsset(contentful_id: { eq: "5cT7AboUl8x3BAwddPe6TZ" }) {
        gatsbyImageData(width: 80, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  return (
    <IconContainer checkWeight={checkWeight}>
      <GatsbyImage
        image={logoImage.contentfulAsset.gatsbyImageData}
        alt='Icon checked'
      />
    </IconContainer>
  );
}
